import MainComponent from './MainComponent'

export default (api) => {
    api.ui.showDialog(MainComponent, {}, {
        title: 'Configuration test tool',
        primary: 'Apply',
        secondary: 'Cancel',
        tertiary: [
            {
                caption: 'Reset configuration',
                callback: () => {
                    // Clear local storage configuration
                    api.settings.delete('__global__', 'localConfiguration')
                    api.settings.delete('__global__', 'localConfigOverridden')
                    api.settings.delete('__global__', 'localConfigAdded')
                    api.settings.delete('__global__', 'localConfigRemoved')
                    api.browser.reload()
                }
            }
        ],
        takeover: true
    })
}
